import React, { useContext } from 'react'

import { IconButton } from '@driftt/dds'
import { faGear } from '@driftt/dds.icons/light/faGear'

import PreferencesModal, { PrefrencesMenuItem } from 'components/PreferencesModal'
import { ICPSettingsContext } from 'context/icpSettingsContext'
import useSavedFilters from 'hooks/useSavedFilters'

const NotificationSettings = () => {
  const { showPreferencesModal, setShowPreferencesModal } = useContext(ICPSettingsContext)
  const { sharedFilters, privateFilters } = useSavedFilters()

  const handleNavigate = () => {
    setShowPreferencesModal(true)
  }

  return (
    <>
      <IconButton
        onClick={handleNavigate}
        size="default"
        variant="education"
        css={{
          height: '32px',
          width: '46px',
          '&:hover': {
            backgroundColor: '$gray2',
            borderColor: '$gray2'
          }
        }}
        title="Manage preferences"
        icon={faGear}
      />
      <PreferencesModal
        open={showPreferencesModal}
        setModalOpen={setShowPreferencesModal}
        sharedFilters={sharedFilters}
        privateFilters={privateFilters}
        defaultTab={PrefrencesMenuItem.FILTERS}
      />
    </>
  )
}

export default NotificationSettings
